import React from "react";
import LogisticsServices from "../../components/service-pages/logistics-services/LogisticsServices";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { getRouteLocalizationNamespaces } from "../../methods/getRouteLocalizationNamespaces";
import { FaqsResponse } from "@vahak/core/dist/_services/faq.service";
import {
    getLogisticsServicesPageLayout,
    getLogisticsServicesStaticProps
} from "../../components/service-pages/constants/logistics-services-methods";

export default function LogisticsServicesPage({ faqs }: { faqs: FaqsResponse[] }) {
    return <LogisticsServices faqs={faqs} />;
}

LogisticsServicesPage.getLayout = getLogisticsServicesPageLayout;

export async function getStaticProps({ locale }: any) {
    return {
        props: {
            isMobile: false,
            ...(await getLogisticsServicesStaticProps()),
            ...(await serverSideTranslations(locale, getRouteLocalizationNamespaces("servicePages")))
        }
    };
}
